export default "__VITE_ASSET__BFHr0_Zc__"